<template>
  <ui-dialog
    :isVisible="visible"
    :title="title"
    :isLoading="isLoading"
    ref="dialog"
    customClass="dialog-purchase-attach-supplier"
    @close="handleClose"
  >
    <el-form>
      <el-form-item
        :label="L10n('select-attach-supplier')"
        class="material-style"
      >
        <select-rfq-2
          :value.sync="rfq2ID"
          @update:value="handleUpdateRFQ2ID"
        />
      </el-form-item>
    </el-form>
    <form-rfq-2-create
      v-show="rfq2ID"
      ref="form"
      :model="formModel"
      :data="rfq2Data"
    />
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        isCancel
        @command="commandController">
        <div class="control control-create-edit btn-mobile-full" v-if="rfq2ID">
          <button
            type="button"
            class="btn btn-control fill-dark-green btn-size-s btn-mobile-full"
            @click.prevent="handleAttach"
            v-html="L10n('attach')"/>
        </div>
      </form-controls>
    </template>
  </ui-dialog>
</template>

<script>
import { ServiceRFQ2s } from '@/services/RFQ2s'
import { getDefaultRFQID } from '@/utils/shared'

export default {
  name: 'DialogAttachRFQ2',
  components: {
    'ui-dialog': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/Dialog'),
    'form-rfq-2-create': () => import(/* webpackChunkName: 'RFQPurchase' */ './FormRFQ2Create'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'select-rfq-2': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectRFQ2s')
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    rfqid: {
      required: true
    }
  },
  data () {
    return {
      rfq2ID: null,
      isLoading: false,
      rfq2Data: {},
      visible: false
    }
  },
  computed: {
    title () {
      return this.rfq2Data.rfqid
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler (isVisible) {
        this.visible = isVisible
        this.rfq2ID = null
        this.reset()
      }
    }
  },
  methods: {
    handleUpdateRFQ2ID (rfq2ID) {
      if (!rfq2ID) return
      this.isLoading = true
      ServiceRFQ2s.get(rfq2ID)
        .then(({ data }) => {
          this.rfq2Data = data
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    commandController (command) {
      if (command === 'cancel') {
        this.handleClose()
      }
    },
    formModel () {
      let model = {
        ...ServiceRFQ2s.getModel(),
        rfqid: getDefaultRFQID(),
        employeeID: this.$store.getters.get('currentUser').employeeID
      }
      return model
    },
    reset () {
      this.rfq2Data = this.formModel()
    },
    handleAttach () {
      if (!this.rfq2ID) return
      const form = this.$refs.form
      form.validate()
        .then(() => {
          const data = form.getData()
          this.attachRFQ2s(data)
        })
    },
    attachRFQ2s (data) {
      this.isLoading = true
      return ServiceRFQ2s.patch({ ...data, rfqid: this.rfqid })
        .then(_ => {
          this.handleClose()
          this.$emit('onAttached')
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleClose () {
      this.$emit('update:isVisible', false)
    }
  }
}
</script>
<style lang="stylus">
  .dialog-purchase-attach-supplier{
    width: 100%;
    max-width 100rem;
  }
</style>
